
import type { FC } from 'react';
import { useCallback, useEffect, useState, useMemo } from 'react';

import { hasClass } from '@/utils/dom';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IObjNumber, IObjString, IAIDragQuestionProps, IlistItem } from '@/utils/ctype';
import GroupTitle from '../../../components/GroupTitle';
import Blocker from '../../../components/Blocker';
import DragAI from '../../../components/DragAI';
import DropAI from '../../../components/DropAI';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';


const Container: FC<IAIDragQuestionProps> = function SummaryWithOptions(props) {

  const { data, answerMap, groupId, keyIndex, answerAllText} = props;

  const { collect, collect_option, list, type} = data || {};

  const {collectIdToContentMap, collectIdToTitleMap, listIdToIndexMap} = useMemo(() => {
    const collectIdToContentMap: IObjString = {};
    const collectIdToTitleMap:IObjString = {};
    const listIdToIndexMap: IObjNumber = {};
    collect_option.list.forEach((item, index: number) => {
      collectIdToTitleMap[item.id] = item.title;
      collectIdToContentMap[item.id] = item.content;
    });
    list.forEach((item: {id: number;}, index: number) => {
      listIdToIndexMap[item.id] = index;
    });
    return {collectIdToContentMap,collectIdToTitleMap, listIdToIndexMap };
  }, [collect_option.list]);

  const createAIType = useCallback((item: IlistItem, answer: string) => {
    const letter = collectIdToTitleMap[answer];
    if (item?.display_answer === letter) {
      return 'success';
    } else {
      return 'fail';
    }
  }, [collectIdToTitleMap]);

  const TransportSurvey = (text: string ) => {
    const textArr = text.split('\n');
    return textArr.map((itemText, index) => {
      if (itemText) {
        return (
          <div className={style.completion} key={index}>
            {replacePlaceholder(itemText)}
          </div>
        );
      } else {
        return (
          <div key={index + '_br'}>
            <br />
          </div>
        );
      }
    });
  };

  const replacePlaceholder = (str: string) => {
    // 正则表达式匹配 $数字$
    const regex = /\$(\d+)\$/g;
    const parts = str.split(regex);
    const elements = parts.map((part, partIndex) => {
      // parts 中的奇数索引是数字，偶数索引是普通文本
      if (partIndex % 2 === 1) {
        const index =listIdToIndexMap[part];
        if (index !== undefined) {
          const item = list[index];
          const key = `${groupId}_${type}_${item.id}`;
          const answer = answerMap[key] && answerMap[key][0];
          const resultType = createAIType(item, answer);
          return <DropAI
            data={item}
            key={index}
            type={resultType} 
            answerKey={`answerAllText.${item.number - 1}`}
            answer={answerAllText[item.number - 1] || collectIdToContentMap[answer]}
            dataKey={`question.question.${keyIndex}.list.${index}.display_answerHtml`}
            playAudio={()=> {playAudio(item);}} 
            parsingAI={() => {parsingAI(item);}} 
            blankBoxClass={style.blankBox}
            id={`question${item.number}`}
          />;
        } else {
          return null;
        }
      } else {
        return <HtmlParser htmlString={part} key={partIndex}></HtmlParser>;
      }
    });
    return elements;
  };

  return (
    <div className={style.box}>
      <Blocker>
        <GroupTitle title={data.title}/>
        {
          TransportSurvey(collect)
        }
      </Blocker>
      <div className={style.answer}>
        {
          collect_option.list.map((data, index: number) => {
            return (
              <DragAI data={data} key={index} optionClass={style.m3}
                dataKey={`question.question.${keyIndex}.collect_option.list.${index}.content`} 
                titleKey={`$question.question.${keyIndex}.collect_option.list.${index}.title`} />
            );
          })
        }
      </div>
    </div>
  );
};

export default Container;